export default __webpack_public_path__ + "static/media/flying_kick.58ed648f.gif";